var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-page"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subject)?_c('div',{staticClass:"subject"},[_vm._v(_vm._s(_vm.subject))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }